import { Component, Inject, OnInit } from '@angular/core';
import { Position, Package } from 'src/app/models/inventory-positions.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Observable, map, Subject } from 'rxjs';
import { startWith, toArray, filter } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-position-details-modal',
  templateUrl: './position-details-modal.component.html',
  styleUrls: ['./position-details-modal.component.scss']
})
export class PositionDetailsModalComponent {
  form!: FormGroup;
  selectedPosition: string = '';
  selectedPackage: string = '';
  current_position_uuid: string = '';
  positions: Position[];
  packages: Package[];
  filteredPositions: Observable<Position[]> | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { positions: Position[], uuid: string, packages: Package[], position_uuid: string, mode: string },
    private fb: FormBuilder, private http: HttpClient, private dialogRef: MatDialogRef<PositionDetailsModalComponent>
  ) {
    this.positions = data.positions;
    this.packages = data.packages;
    this.current_position_uuid = data.position_uuid;
  }

  ngOnInit(): void {
    // Initialize the form with common fields
    this.form = this.fb.group({
      package_uuid: [null, Validators.required],
      inventory_position_package_uuid: [null, Validators.required],
    });

    // If the mode is 'move', add fields for moving to a new position
    if (this.data.mode === 'move') {
      this.form.addControl('selectedPosition', new FormControl(null, Validators.required));
      this.form.addControl('new_position_uuid', new FormControl(null, Validators.required));
      this.form.addControl('current_position_uuid', new FormControl(this.current_position_uuid, Validators.required));
    }

    //Populate the positions list in the switching contact feature and set new position uuid selected
    this.form.get('selectedPosition')?.valueChanges.subscribe((data) => {
      const index = this.positions?.findIndex((item: any) => item.inventory_position_name === data);
      if (index !== -1 && this.positions && index !== undefined) {
        var position_selected_uuid = this.positions[index]?.inventory_position_uuid;
        this.form.get('new_position_uuid')?.setValue(position_selected_uuid);
      }
    });

    // Set inventory_position_package_uuid when a package is selected
    this.form.get('package_uuid')?.valueChanges.subscribe((data) => {
      const index = this.packages?.findIndex((pkg: any) => pkg.package_uuid === data);
      if (index !== -1 && this.packages && index !== undefined) {
        var inventory_position_package_uuid = this.packages[index]?.inventory_position_package_uuid;
        this.form.get('inventory_position_package_uuid')?.setValue(inventory_position_package_uuid)
      }
    })

    //Filter positions
    this.filteredPositions = this.form.get('selectedPosition')?.valueChanges
      .pipe(
        startWith(''),
        filter(value => value.length >= 3), // Only proceed if the input length is 3 or more
        map(positions => positions ? this.filterPositions(positions) : this.positions.slice())
      );
  }

  filterPositions(name: string) {
    return this.positions.filter(positions =>
      positions.inventory_position_name?.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  onClose(): void {
    this.dialogRef.close()
  }

  save() {
    if (this.form.valid) {
      if (this.data.mode === 'delete') {
        // Log form data for removing a package
        console.log('Form data for removing a package: ', this.form.value);
        const delete_url = `/api/inventory/inventory_position_packages_move.php?inventory_position_package_uuid=${this.form.value.inventory_position_package_uuid}`
        return this.http.delete<any>(delete_url)
          .subscribe(response => {
            console.log('Delete Response', response)
            this.dialogRef.close({ success: true, action: 'delete' });
          })
      } else {
        // Handle saving for moving package to new position
        console.log('Post data for moving package: ', this.form.value);
        const post_url = '/api/inventory/inventory_position_packages_move.php';
        return this.http.post<any>(post_url, this.form.value)
          .subscribe(response => {
            console.log('Post Response: ', response);
            this.dialogRef.close({ success: true, action: 'move' });
          });
      }
    } else {
      return;
    }
  }
}